import React, { useState } from "react";
import { FormattedMessage } from 'react-intl';
import DashboardLayout from "../layout/Dashboard";
import { Messages } from '../../components/layout/Messages/Messages';
import {
  PageHeader,
  PageSurface,
  PageWorkspace
} from '../../components/layout/Workspace';
import { AdminManage } from "../../components/pages/admin/users/AdminManage";
import { getAdminUsers as getUsersApi } from "../../api/admin/users";
import { getGroups as getGroupsApi } from "../../api/admin/groups";
import {
  NOTIFICATION_ADMIN_ACTIONS,
  NOTIFICATION_ADMIN_GROUP_ACTIONS
} from '../../config/notifications';
import { ACL, PAGE_CONTEXTS } from '../../config/constants';
import { NoRights } from '../../components/layout/Permissions/NoRights';
import './ManageAdmin.scss';

function ManageAdmin(props) {
  const [ users, setUsers ] = useState( null );
  const [ metaUsers, setMetaUsers ] = useState( null );
  const [ groups, setGroups ] = useState( null );
  const [ metaGroups, setMetaGroups ] = useState( null );
  const [ rowsPerPageUsers, setRowsPerPageUsers ] = useState( 10 );
  const [ rowsPerPageGroups, setRowsPerPageGroups ] = useState( 10 );

  /**
   * Get users
   * @param {number} [page]
   * @param {string} [sortField]
   * @param {string} [sortDirection]
   * @param {string} [searchText]
   * @param {boolean} [hideNotification]
   */
  const getUsers = (page, sortField, sortDirection, searchText, hideNotification= false) => {
    if (! ACL.ADMIN.USERS.LIST.hasAccess()) {
      return;
    }

    getUsersApi( {
      pagination: {
        page: page,
        sort_by: sortField,
        sort: sortDirection,
        q: searchText,
        per_page: rowsPerPageUsers,
        page_context: PAGE_CONTEXTS.ADMIN_USER.LIST
      },
      hideNotification: hideNotification,
    } ).then( (response) => {
      if (response && response.data && response.meta) {
        setUsers( response.data );
        setMetaUsers( response.meta );
      }
    } );

  };

  /**
   * Get groups
   * @param {number} [page]
   * @param {string} [sortField]
   * @param {string} [sortDirection]
   * @param {string} [searchText]
   * @param {boolean} [hideNotification]
   */
  const getGroups = (page, sortField, sortDirection, searchText, hideNotification = false) => {
    if (! ACL.ADMIN.GROUPS.LIST.hasAccess()) {
      return;
    }

    getGroupsApi( {
      pagination: {
        page: page,
        sort_by: sortField,
        sort: sortDirection,
        q: searchText,
        per_page: rowsPerPageGroups,
        page_context: PAGE_CONTEXTS.ADMIN_GROUP.LIST,
      },
      hideNotification: hideNotification,
    } ).then( (response) => {
      if (response && response.data && response.meta) {
        setGroups( response.data );
        setMetaGroups( response.meta );
      }
    } );
  };
  const pageHeader = (
    <PageHeader
      title={<FormattedMessage id="pages.admins.manage.title"/>}
    />
  );
  const hasNoPageRights = !ACL.ADMIN.USERS.LIST.hasAccess() && !ACL.ADMIN.GROUPS.LIST.hasAccess();

  return (
    <DashboardLayout location={props.location} className="dashboard" workspace={true}>
      <PageWorkspace className="admin-management-workspace">
        <div className="admin-management-notifications">
          <Messages/>
          <Messages notificationId={NOTIFICATION_ADMIN_ACTIONS}/>
          <Messages notificationId={NOTIFICATION_ADMIN_GROUP_ACTIONS}/>
        </div>
        {hasNoPageRights ? (
          <>
            {pageHeader}
            <PageSurface className="admin-management-surface">
              <NoRights/>
            </PageSurface>
          </>
        ) : (
          <AdminManage
              header={pageHeader}
              location={props.location}
              users={users}
              metaUsers={metaUsers}
              getUsers={getUsers}
              rowsPerPageUsers={rowsPerPageUsers}
              setRowsPerPageUsers={setRowsPerPageUsers}
              groups={groups}
              metaGroups={metaGroups}
              getGroups={getGroups}
              rowsPerPageGroups={rowsPerPageGroups}
              setRowsPerPageGroups={setRowsPerPageGroups}
            />
        )}
      </PageWorkspace>
    </DashboardLayout>
  );
}

export { ManageAdmin };
